<app-notes [moduleId]="moduleId" [entityId]="clientId" urlPrefix="/client"></app-notes>
